import { render } from "./registrationStep6.vue?vue&type=template&id=7e559b70&scoped=true"
import script from "./registrationStep6.vue?vue&type=script&lang=js"
export * from "./registrationStep6.vue?vue&type=script&lang=js"

import "./registrationStep6.vue?vue&type=style&index=0&id=7e559b70&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e559b70"]])

export default __exports__